// extracted by mini-css-extract-plugin
export default {"cls1":"UserTaggingPingBodyStyles-cls1_DiO","cls2":"UserTaggingPingBodyStyles-cls2__oV UserTaggingPingBodyStyles-cls1_DiO"};